import { render, staticRenderFns } from "./OptionEditDisabledIfTab.vue?vue&type=template&id=b3d507e8"
import script from "./OptionEditDisabledIfTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditDisabledIfTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports